import { render, staticRenderFns } from "./obit-org.vue?vue&type=template&id=6a1e5c1a&"
import script from "./obit-org.vue?vue&type=script&lang=js&"
export * from "./obit-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports